// export const initialKey = (formData) => {
//     const Options = {};
//     !!formData && formData.length > 0 &&
//         formData.forEach((element) => {
//             Options[element.name] = element.type === "checkBox" ? false : ""
//         });
//     return Options;
// }

// export const initialValidation = (formData) => {
//     const Options = {};
//     !!formData && formData.length > 0 &&
//         formData.forEach((element) => {
//             Options[element.name] =
//                 element.type === "phone" ?
//                     Yup.string().test('is-valid-number', <FormattedMessage id={`ValidationFieldPhone`} />, value => {
//                         return phoneRegExp.test(value);
//                     }).required(<FormattedMessage id={`ValidationField`} />)
//                     :
//                     element.type === "checkBox" ? Yup.boolean().oneOf([true], <FormattedMessage id={`ValidationField`} />).required(<FormattedMessage id={`ValidationField`} />)
//                         :
//                         Yup.string().required(<FormattedMessage id={`ValidationField`} />)
//         });
//     return Options;
// }
import * as Yup from "yup";
import { FormattedMessage } from "react-intl";

const phoneRegExp =
    /^(?:\+\d{1,3}\d{8,14}|\(\d{3}\)\s*\d{9,12}|\d{8,14})$/;
const numberEx =
    /[0-9]/;

export const initialKey = (formData, isNull = null) => {
    if (!!isNull) {
        const Options = {};
        !!formData && formData.length > 0 &&
            formData.forEach((element) => {
                Options[element.name] = element.type === "checkBox" ? false :
                    element.type === "DropDownMulti" ? [] : null
            });
        return Options;
    } else {
        const Options = {};
        !!formData && formData.length > 0 &&
            formData.forEach((element) => {
                Options[element.name] = element.type === "checkBox" ? false :
                    element.type === "DropDownMulti" ? [] : ""
            });
        return Options;
    }
}

export const initialValidation = (formData) => {
    const Options = {};
    !!formData && formData.length > 0 &&
        formData.forEach((element) => {
            if (!!element.required) {
                Options[element.name] =
                    element.type === "phone" ?
                        Yup.string().test('is-valid-number', <FormattedMessage id={`ValidationFieldPhone`} />, value => {
                            return phoneRegExp.test(value);
                        }).required(<FormattedMessage id={`ValidationField`} />)
                        :
                        element.type === "checkBox" ? Yup.boolean().oneOf([true], <FormattedMessage id={`ValidationField`} />).required(<FormattedMessage id={`ValidationField`} />)
                            :
                            element.type === "DropDownMulti" ? Yup.array().min(1, <FormattedMessage id={`ValidationField`} />).required(<FormattedMessage id={`ValidationField`} />)
                                :
                                Yup.string().required(<FormattedMessage id={`ValidationField`} />)
            }
        });
    return Options;
}

export async function getImageAsBinary(url) {
    const response = await fetch(url);
    const arrayBuffer = await response.arrayBuffer(); // binary data
    return arrayBuffer;
}

export async function getImageAsBlob(url) {
    const response = await fetch(url);
    const blob = await response.blob(); // أيضاً binary لكن بشكل Blob
    return blob;
}

export async function imageUrlToFile(url) {
    const response = await fetch(url);
    const blob = await response.blob();

    // نحاول استخراج نوع الصورة (مثل image/png أو image/jpeg)
    const mimeType = blob.type || 'image/png'; // fallback

    // استخراج الامتداد من النوع
    const extension = mimeType.split('/')[1] || 'png';

    // إنشاء كائن File
    const file = new File([blob], `downloaded-image.${extension}`, { type: mimeType });

    return file;
}